import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Fade extends withIntersectionObserver(Base, {
  threshold: 0.01,
}) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Fade',
    options: {
      delay: {
        type: Number,
        default: 0.2,
      },
    },
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    const delay = this.$options.delay === 0.2 ? this.$options.delay : this.$options.delay / 8;
    this.$el.style.transitionDelay = `${delay}s`;

    if (this.$el.classList.contains('inview')) {
      return;
    }

    this.$el.classList.add('inview');
  }
}
